import * as FontSizes from '@bubble-ui/particle-font-sizes';
export var calculateLabelMotion = _ref => {
  var {
    big,
    hasValue,
    focused
  } = _ref;
  return {
    fontSize: focused || hasValue ? FontSizes.SIZE_DETAIL : big ? FontSizes.SIZE_EXTRA_LARGE : FontSizes.SIZE_DEFAULT,
    marginTop: big ? focused || hasValue ? 6 : 20.5 : focused || hasValue ? 6 : 16
  };
};
//# sourceMappingURL=calculateLabelMotion.js.map